import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VSubheader,[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.home.welcome'))+" "+_vm._s(_vm.companyName)+" ")]),_c(VDivider),_c('my-recent-qr-codes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }